import { useContext, useEffect } from "react";

import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import LandingAnimation from "../../Helpers/LandingAnimation";
import { UserContext } from "../UserContext";
import { LocationForm } from "./LocationForm";

export const LocationDetails = () => {

	const { handleTitle, selectedLocation } = useContext(UserContext);
	const { t } = useTranslation();

	useEffect(() => {
		handleTitle(t("common.locations"));
	}, []);

	return (
		<LandingAnimation>
			{selectedLocation != null && selectedLocation != undefined && (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center"
				}}
			>
				<LocationForm
					locationData={selectedLocation}
				/>
			</Box>
			)}
		</LandingAnimation>
	);
};
